import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { ExternalLink, Logo, NamedLink } from '../../components';

import css from './FooterContainer.module.css';
import Icons from '../../components/Icons/Icons';

import logo from '../../assets/nilianceLogo.jpg';

function FooterContainer(props) {
  const intl = useIntl();

  return (
    <div className={css.footer}>
      <div className={css.footerTop}>
        <div className={css.contentWidth}>
          <div className={css.leftBlock}>
            <div className={css.linksBlock}>
              <NamedLink
                className={css.logo}
                name="LandingPage"
                title={intl.formatMessage({ id: 'Topbar.logoIcon' })}
              >
                <img src={logo} alt="logo" />
              </NamedLink>
              <p>
                <FormattedMessage id="Footer.guidedByHeart" />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={css.footerBottom}>
        <div className={css.contentWidth}>
          <div className={css.footerBottomLeft}>
            <p>{intl.formatMessage({ id: 'Footer.FooterText' })}</p>
          </div>
          <div className={css.footerBottomRight}>
            <ExternalLink href="https://www.facebook.com" className={css.link}>
              <Icons name="facebook" />
            </ExternalLink>{' '}
            <ExternalLink href="https://www.instagram.com" className={css.link}>
              <Icons name="instagram" />
            </ExternalLink>{' '}
            <ExternalLink className={css.link} href="https://www.linkedin.com">
              <Icons name="linkedin" />
            </ExternalLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FooterContainer;
